import { deleteRequest, get, patch, post } from "./api";

const fetchCustomers = (profile, params = {}, dropdown_format = false) => {
  if (profile?.hasAccountingAccess && profile?.type === "accountant") {
    params.having_profile = profile.id;
  } else if (profile?.type === "client") {
    params.having_profile = profile.id;
  }

  return get("/api/v2/customers/", params, dropdown_format);
};

const fetchCustomer = (id) => {
  return get(`/api/v2/customers/${id}/`);
};

const fetchAllCustomers = (profile, params = {}, dropdown_format = false) => {
  if (profile?.hasAccountingAccess && profile?.type === "accountant") {
    params.having_profile = profile.id;
  } else if (profile?.type === "client") {
    params.having_profile = profile.id;
  }

  return get("/api/v2/all_customers/", params, dropdown_format);
};

const fetchGroupCustomers = (params = {}, dropdown_format = false) => {
  return get("/api/v2/groupcustomers/", params, dropdown_format);
};

const updateCustomerGroup = (customerId, groupId, formData) => {
  return patch(`/api/v2/customers/${customerId}/customergroup/${groupId}/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const createCustomerGroup = (customerId, formData) => {
  return post(`/api/v2/customers/${customerId}/customergroup/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const updateCustomer = (id, data) => {
  return patch(`/api/v2/customers/${id}/`, data, "multipart/form-data");
};

const createCustomer = (data) => {
  data.is_active = true;
  return post("/api/v2/customers/", data, "multipart/form-data");
};

const deleteCustomer = (id) => {
  return deleteRequest(`/api/v2/customers/${id}/`);
};

const exportCustomers = (customerIds = null) => {
  const data = customerIds ? { customer_ids: customerIds } : {};
  return post("/api/v2/export_customers/", data);
};

const uploadCustomerData = (file) => {
  return post("/api/v2/customer_data_import/", file, "multipart/form-data");
};

const uploadCustomerIndicators = (file) => {
  return post(
    "/api/v2/customer_indicator_import/",
    file,
    "multipart/form-data"
  );
};

const updateCustomerBulk = (params) => {
  return patch(
    "/api/v2/customers/bulk_update/",
    params,
  );
};

const linkUserToCustomer = (customerId, profileId) => {
  return post(`/api/v2/customers/${customerId}/link_user/`, { profile_id: profileId });
};

const unlinkUserFromCustomer = (customerId, profileId) => {
  return post(`/api/v2/customers/${customerId}/unlink_user/`, { profile_id: profileId });
};

const bulkLinkUsers = (customerId, usersToLink, usersToUnlink, profileRoles = {}) => {
  return post(`/api/v2/customers/${customerId}/bulk_link_users/`, { 
    profile_ids: usersToLink,
    unlink_profile_ids: usersToUnlink,
    profile_roles: profileRoles
  });
};

const updateCustomerIndvidual = (customerId, params) => {
  return patch(
    `/api/v2/customers/${customerId}/`,
    params,
    "multipart/form-data"
  );
};

const setCustomerNamespace = (customerId, namespace) => {
  return post(`/api/v2/customers/${customerId}/namespace/`, { namespace });
};

export {
  fetchCustomers,
  fetchCustomer,
  fetchAllCustomers,
  fetchGroupCustomers,
  createCustomerGroup,
  exportCustomers,
  updateCustomerGroup,
  updateCustomer,
  createCustomer,
  deleteCustomer,
  uploadCustomerData,
  uploadCustomerIndicators,
  updateCustomerBulk,
  updateCustomerIndvidual,
  setCustomerNamespace,
  linkUserToCustomer,
  unlinkUserFromCustomer,
  bulkLinkUsers
};
